import http from '@/plugs/httpServer';
import { serverName } from '@wj/common'
let feather_campus = "feather-campus"
// 查看奖励详情
export function getResumeDetail(data: object) {
	return http({
		method: 'GET',
		url: `${feather_campus}/resume/getResume`,
		params: data,
	})
}

// 修改简历
export function editResume(data: object) {
	return http({
		method: 'POST',
		url: `${feather_campus}/resume/editResume`,
		data: data,
	})
}

// 查询字典
export function getDictionaryData(data: object) {
	return http({
		method: 'GET',
		url: `${feather_campus}/resume/getDicts`,
		params: data,
	})
}

// 发送验证码
export function getSmsCode(data: object) {
	return http({
		method: 'GET',
		url: `${feather_campus}/user/getSmsCode`,
		params: data,
	})
}

// 用户注册
export function register(data: object) {
	return http({
		method: 'POST',
		url: `${feather_campus}/resume/register`,
		data: data,
	})
}

// 简历投递
export function deliverResume(data: object) {
	return http({
		method: 'POST',
		url: `${feather_campus}/deliver/insertDeliver`,
		data: data,
	})
}
// 用户登录
export function login(data: object) {
	return http({
		method: 'POST',
		url: `${feather_campus}/auth/login`,
		data: data,
	})
}

// 密码修改
export function changePassword(data: object) {
	return http({
		method: 'GET',
		url: `${feather_campus}/auth/changePwd`,
		params: data,
	})
}

// 列表查询
export function getListDeliver(data: object) {
	return http({
		method: 'POST',
		url: `${feather_campus}/deliver/listDeliver`,
		data: data,
	})
}

// 岗位列表
export function getJobs(data: object) {
	return http({
		method: 'POST',
		url: `${feather_campus}/job/listJob`,
		data: data,
	})
}

// 简历上传
export function uploadFile(data: object) {
	return http({
		method: 'POST',
		url: `${feather_campus}/file/upload`,
		data: data,
	})
}

//定时短信开关
export function timeoutSwitch(data: object) {
	return http({
		method: 'POST',
		url: `${feather_campus}/task/switchTask`,
		data: data,
	})
}
//获取短信模板
export function listSms(data: object) {
	return http({
		method: 'POST',
		url: `${feather_campus}/sms/listSms`,
		data: data,
	})
}

//编辑短信模板
export function editSms(data: object) {
	return http({
		method: 'POST',
		url: `${feather_campus}/sms/editSms`,
		data: data,
	})
}

// 获取岗位模板列表
export function getPosition(data: object) {
	return http({
		method: 'GET',
		url: `${feather_campus}/position/getPosition`,
		params: data,
	})
}

// 获取岗位
export function getJobList(data: object) {
	return http({
		method: 'POST',
		url: `${feather_campus}/position/getPositionById`,
		data: data,
	})
}
// 新增岗位模板
export function insertPosition(data: object) {
	return http({
		method: 'POST',
		url: `${feather_campus}/position/insertPosition`,
		data: data,
	})
}
// 删除岗位模板
export function delPosition(data: object) {
	return http({
		method: 'POST',
		url: `${feather_campus}/position/delPosition`,
		data: data,
	})
}

// 修改岗位模板
export function updatePosition(data: object) {
	return http({
		method: 'POST',
		url: `${feather_campus}/position/updatePosition`,
		data: data,
	})
}

// 用户签到
export function signin(data: object) {
	return http({
		method: 'POST',
		url: `${feather_campus}/deliver/checkin`,
		data: data,
	})
}


